import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-admin/shared/api/axios";
import { SelectionDropdown } from "@libs/zapi-ui/custom";
import { TAdminListProjectsResponse } from "@/zapi-admin/shared/components/ProjectSelect/model/schema";

type TProjectSelectProps = {
  projectId: string;
  setProjectId: (project: string) => void;
};

export function ProjectSelect({ setProjectId, projectId }: TProjectSelectProps) {
  const { data } = useQuery<{ id: string; label: string; value: string }[]>({
    queryKey: ["get-projects"],
    queryFn: async () => {
      const response = await $api.get<{
        data: TAdminListProjectsResponse;
      }>("/admin/projects");
      return (
        response?.data?.data
          ?.map((i) => ({
            id: i.id + "",
            value: `${i.id} ${i.name} ${i.organization.id} ${i.organization.name}`,
            label: `${i.id}: ${i.name} (Org-ID: ${i.organization.id} - Org-Name: ${i.organization.name})`
          }))
          ?.sort((a, b) => a.label.localeCompare(b.label)) || []
      );
    }
  });

  return (
    <div className="space-y-2 w-[258px]">
      <SelectionDropdown
        placeholder="Select Project"
        options={[{ label: "All Projects", value: "" }, ...(data || [])]}
        value={data?.find((i) => i.id === projectId)?.value}
        onChange={(v) => {
          const vId = data?.find((i) => i.value === v)?.id || "";
          setProjectId(vId);
          localStorage.setItem("project", vId);
        }}
        className="rounded-[8px]"
      />
    </div>
  );
}
